import {
  subtype as s,
  subtypeCatalog as c,
  withSubtypeImages as withImages,
} from './catalog-builder';

export const ACCESSORY_PRODUCT_SUBTYPE_CATALOGS = [
  c(
    'shoe',
    ['Shoe'],
    withImages('shoe', [
      s('sneaker', 'Sneaker', 'closed athletic upper', 'flat flexible sole'),
      s(
        'running-shoe',
        'Running shoe',
        'cushioned heel-to-toe sole',
        'secure laced upper'
      ),
      s('loafer', 'Loafer', 'low slip-on upper', 'exposed ankle'),
      s('boot', 'Boot', 'upper extending above ankle', 'enclosed foot'),
      s('sandal', 'Sandal', 'open upper sections', 'strap-secured footbed'),
      s('mule', 'Mule', 'closed or strapped forefoot', 'open back'),
      s('pump', 'Pump', 'low-cut closed upper', 'raised heel'),
      s('oxford', 'Oxford', 'closed lacing quarters', 'low formal upper'),
      s('derby', 'Derby', 'open lacing quarters', 'low formal upper'),
      s('slip-on', 'Slip-on', 'laceless closed upper', 'easy-entry opening'),
      s('ballet-flat', 'Ballet flat', 'very low-cut upper', 'flat thin sole'),
      s('mary-jane', 'Mary Jane', 'low closed toe', 'instep strap'),
      s(
        'espadrille',
        'Espadrille',
        'rope-wrapped sole edge',
        'closed or open upper'
      ),
      s('clog', 'Clog', 'roomy closed toe', 'open or low back', 'rigid sole'),
      s('slipper', 'Slipper', 'soft low upper', 'light indoor sole'),
    ])
  ),
  c(
    'earrings',
    ['Earrings'],
    withImages('earrings', [
      s('stud', 'Stud', 'ornament sits on earlobe', 'straight post closure'),
      s('hoop', 'Hoop', 'circular body', 'earlobe-threading opening'),
      s('huggie', 'Huggie', 'small close-fitting hoop', 'hinged closure'),
      s(
        'drop',
        'Drop',
        'single element below lobe',
        'fixed vertical suspension'
      ),
      s(
        'dangle',
        'Dangle',
        'multiple articulated hanging elements',
        'free movement'
      ),
      s(
        'chandelier',
        'Chandelier',
        'tiered branching drops',
        'wide lower silhouette'
      ),
      s(
        'ear-cuff',
        'Ear cuff',
        'open band around ear edge',
        'no lobe post required'
      ),
      s(
        'threader',
        'Threader',
        'fine chain through piercing',
        'long front and back drops'
      ),
      s(
        'ear-climber',
        'Ear climber',
        'elongated ornament up ear',
        'anchored lobe post'
      ),
      s(
        'jacket',
        'Jacket',
        'front stud element',
        'separate ornament behind lobe'
      ),
      s('teardrop', 'Teardrop', 'tapered top', 'rounded hanging lower form'),
      s(
        'clip-on',
        'Clip-on',
        'ornament sits on lobe',
        'non-pierced clip closure'
      ),
    ])
  ),
  c(
    'tote-bag',
    ['Tote Bag'],
    withImages('tote-bag', [
      s(
        'open-top',
        'Open-top',
        'two parallel handles',
        'unfastened top opening'
      ),
      s('zip-top', 'Zip-top', 'two parallel handles', 'full top zipper'),
      s('shopper', 'Shopper', 'wide rectangular body', 'long carry handles'),
      s('market', 'Market', 'broad open body', 'reinforced carry handles'),
      s('boat', 'Boat', 'wide flat base', 'tapered upper sides'),
      s('beach', 'Beach', 'oversized open body', 'wide carry opening'),
      s(
        'structured',
        'Structured',
        'self-supporting body',
        'defined base and side panels'
      ),
      s('bucket', 'Bucket', 'round or oval base', 'upright cylindrical body'),
      s(
        'foldable',
        'Foldable',
        'collapsible unstructured body',
        'integrated carry handles'
      ),
      s('utility', 'Utility', 'open tote body', 'external functional pockets'),
    ])
  ),
  c(
    'shoulder-bag',
    ['Shoulder-Bag', 'Shoulder Bag'],
    withImages('shoulder-bag', [
      s('hobo', 'Hobo', 'crescent slouch body', 'single shoulder strap'),
      s(
        'baguette',
        'Baguette',
        'short horizontal body',
        'short shoulder strap'
      ),
      s('saddle', 'Saddle', 'curved-bottom flap body', 'long shoulder strap'),
      s('crescent', 'Crescent', 'curved crescent body', 'top-following strap'),
      s('flap', 'Flap', 'front-covering flap', 'shoulder strap'),
      s(
        'structured',
        'Structured',
        'self-supporting body',
        'defined base and gussets'
      ),
      s('pouch', 'Pouch', 'soft compact body', 'gathered or zipped top'),
      s(
        'bucket',
        'Bucket',
        'round base',
        'upright body',
        'drawstring-style opening'
      ),
      s('camera', 'Camera', 'compact box body', 'top zip opening'),
      s('messenger', 'Messenger', 'wide rectangular body', 'large front flap'),
      s('box', 'Box', 'rigid geometric body', 'defined hard edges'),
      s(
        'mini',
        'Mini',
        'small shoulder-scale body',
        'compact strap proportions'
      ),
    ])
  ),
  c(
    'backpack',
    ['Backpack'],
    withImages('backpack', [
      s(
        'daypack',
        'Daypack',
        'compact main compartment',
        'two shoulder straps'
      ),
      s(
        'laptop',
        'Laptop',
        'rectangular protected body',
        'dedicated device compartment'
      ),
      s(
        'hiking',
        'Hiking',
        'tall load-bearing body',
        'supportive harness system'
      ),
      s('travel', 'Travel', 'large carry-on body', 'wide packing access'),
      s(
        'school',
        'School',
        'medium main compartment',
        'front organizer pocket'
      ),
      s('roll-top', 'Roll-top', 'folding top extension', 'top buckle closure'),
      s('drawstring', 'Drawstring', 'soft sack body', 'cord-closed top'),
      s(
        'tactical',
        'Tactical',
        'segmented utility body',
        'external webbing rows'
      ),
      s('sling', 'Sling', 'compact asymmetric body', 'single diagonal strap'),
      s(
        'convertible',
        'Convertible',
        'backpack shoulder straps',
        'alternate carry handles'
      ),
      s('hydration', 'Hydration', 'slim close-back body', 'drink-tube routing'),
      s(
        'camera',
        'Camera',
        'structured padded body',
        'divided equipment access'
      ),
    ])
  ),
  c(
    'glasses',
    ['Glasses'],
    withImages('glasses', [
      s('round', 'Round', 'circular lens rims', 'balanced curved frame front'),
      s(
        'square',
        'Square',
        'equal-height angular lens rims',
        'defined corners'
      ),
      s(
        'rectangle',
        'Rectangle',
        'wide shallow lens rims',
        'straight frame edges'
      ),
      s(
        'oval',
        'Oval',
        'elongated curved lens rims',
        'soft narrow frame front'
      ),
      s('cat-eye', 'Cat-eye', 'upswept outer corners', 'tapered inner rims'),
      s('aviator', 'Aviator', 'teardrop lens rims', 'double bridge'),
      s(
        'wayfarer',
        'Wayfarer',
        'trapezoidal lens rims',
        'thick angled frame front'
      ),
      s('browline', 'Browline', 'emphasized upper frame', 'fine lower rim'),
      s(
        'geometric',
        'Geometric',
        'multi-sided lens rims',
        'faceted frame edges'
      ),
      s(
        'rimless',
        'Rimless',
        'lenses without surrounding rims',
        'direct bridge mounts'
      ),
      s(
        'half-rim',
        'Half-rim',
        'upper or lower partial rims',
        'exposed lens edge'
      ),
      s('pantos', 'Pantos', 'rounded lens rims', 'flattened upper curve'),
    ])
  ),
  c(
    'wrist-watch',
    ['Wrist-Watch', 'Wrist Watch'],
    withImages('wrist-watch', [
      s('dress', 'Dress', 'slim case profile', 'clean restrained dial'),
      s(
        'dive',
        'Dive',
        'rotating timing bezel',
        'high-visibility dial markers'
      ),
      s('field', 'Field', 'simple legible dial', 'durable compact case'),
      s('pilot', 'Pilot', 'large legible dial', 'prominent crown'),
      s(
        'chronograph',
        'Chronograph',
        'multiple timing subdials',
        'case pushers'
      ),
      s(
        'racing',
        'Racing',
        'timing-focused dial',
        'tachymeter-style outer scale'
      ),
      s('gmt', 'GMT', 'additional timezone hand', '24-hour scale'),
      s('sports', 'Sports', 'robust case', 'high-legibility dial'),
      s(
        'digital',
        'Digital',
        'numeric display window',
        'button-controlled case'
      ),
      s(
        'skeleton',
        'Skeleton',
        'openworked dial',
        'visible movement structure'
      ),
      s(
        'moonphase',
        'Moonphase',
        'moon-cycle aperture',
        'calendar-oriented dial'
      ),
      s(
        'smartwatch',
        'Smartwatch',
        'full digital screen',
        'sensor-backed case'
      ),
    ])
  ),
] as const;
